import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_separator_30da60f9__ from "@radix-ui/react-separator";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const Separator = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__.forwardRef(({ className, orientation = 'horizontal', decorative = true, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_separator_30da60f9__.Root, {
        ref: ref,
        decorative: decorative,
        orientation: orientation,
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)('shrink-0 bg-border', 'horizontal' === orientation ? 'h-px w-full' : 'h-full w-px', className),
        ...props
    }));
Separator.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_separator_30da60f9__.Root.displayName;
export { Separator };

//# sourceMappingURL=index.js.map